<template>
  <v-container
    id="Login"
    class="fill-height justify-center"
    tag="section"
  >
    <v-row justify="center">
      <v-col
        cols="12"
        md="6"
      >
        <v-slide-y-transition appear>
          <v-card
            class="pa-3 pa-md-5 mx-auto"
            light
          >
            <pages-heading
              class="text-h3"
              style="color: #4caf50; text-align: center"
            >
              <h3>Aguarde que você será redirecionado</h3>
            </pages-heading>
          </v-card>
        </v-slide-y-transition>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import Login from '../../services/login'
  import utils from '../../services/utils'
  // import Menu from '../../services/menu'

  export default {

    name: 'PageLogin',
    components: {
      PagesHeading: () => import('./components/Heading'),
    },
    mixins: [utils],

    data: () => ({
      exibePf: true,
      valid: false,
      tokencontrato: '',
      verifylink: '',
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: '',
        timeout: 3000,
      },
      imagem: '',
      dialog: {
        visible: false,
        message: '',
      },
      validuser: false,
    }),

    mounted () {
      this.valid = false
      this.invalid = true

      // localStorage.clear()

      if (window.location.href !== 'http://localhost:8080/' && window.location.href !== 'http://apresentacao.bi.magisteste/' && window.location.href !== 'magisbi.com.br' && window.location.href !== 'http://192.168.1.22:8080/') {
        this.verifylink = window.location.href
      }

      if (this.verifylink) {
        Login.verificaLink(this.verifylink).then(resposta => {
          this.empresaNome = resposta.data.empresa

          this.tokencontrato = resposta.data.token

          this.$store.state.versao = resposta.data.versao

          localStorage.setItem('versao', resposta.data.versao)

          localStorage.setItem('tokencontrato', resposta.data.token)
          localStorage.setItem('corPrimaria', resposta.data.corPrimaria)

          this.coresBasesSite()

          this.$router.push('/login')
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, ' Falha na conexão com a internet')
          }
          localStorage.clear()
          this.$router.push('/login')
        })
      }

      // const usuarioLogado = localStorage.getItem('usuarioLogado')

      // const paginaAtual = localStorage.getItem('paginaAtual')

      // if (usuarioLogado) {
      //   this.$router.push(paginaAtual)
      // } else {
      //   localStorage.clear()

      //   if (window.location.href !== 'http://localhost:8080/' && window.location.href !== 'http://apresentacao.bi.magisteste/' && window.location.href !== 'magisbi.com.br' && window.location.href !== 'http://192.168.1.22:8080/') {
      //     this.verifylink = window.location.href
      //   }

      //   if (this.verifylink) {
      //     Login.verificaLink(this.verifylink).then(resposta => {
      //       this.empresaNome = resposta.data.empresa

      //       this.tokencontrato = resposta.data.token

      //       this.$store.state.versao = resposta.data.versao

      //       localStorage.setItem('versao', resposta.data.versao)

      //       localStorage.setItem('tokencontrato', resposta.data.token)
      //       localStorage.setItem('corPrimaria', resposta.data.corPrimaria)

      //       this.coresBasesSite()

      //       this.$router.push('/login')
      //     }).catch(e => {
      //       if (e.message === 'Network Error') {
      //         this.showSnackbar('error', 3000, ' Falha na conexão com a internet')
      //       }
      //       localStorage.clear()
      //       this.$router.push('/login')
      //     })
      //   }
      // }
    },

    methods: {
      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },

      coresBasesSite () {
        /* Código apenas para teste mudança de cores */
        if (localStorage.corPrimaria === '#9C27b0') {
          localStorage.setItem('corSecondaria', '#00bcd4')
          localStorage.setItem('corError', '#ff9800')
        } else if (localStorage.corPrimaria === '#2863af') {
          localStorage.setItem('corSecondaria', '#1B5E20')
          localStorage.setItem('corError', '#FF3D00')
        } else if (localStorage.corPrimaria === '#45a048') {
          localStorage.setItem('corSecondaria', '#2863af')
          localStorage.setItem('corError', '#ff5252')
        } else if (localStorage.corPrimaria === '#ff9800') {
          localStorage.setItem('corSecondaria', '#2E7D32')
          localStorage.setItem('corError', '#D32F2F')
        } else if (localStorage.corPrimaria === '#E91E63') {
          localStorage.setItem('corSecondaria', '#009688')
          localStorage.setItem('corError', '#ff5722')
        } else if (localStorage.corPrimaria === '#FF5252') {
          localStorage.setItem('corSecondaria', '#2979FF')
          localStorage.setItem('corError', '#8D6E63')
        } else if (localStorage.corPrimaria === '#D50000') {
          localStorage.setItem('corSecondaria', '#B2DFDB')
          localStorage.setItem('corError', '#F57F17')
        }
      },

      showDialog (message) {
        this.dialog.visible = true
        this.dialog.message = message
      },
    },
  }
</script>

<style lang="sass">
  .v-text-field input
    font-size: 1.2em

  #login
    .v-list-item__subtitle
      -webkic-line-clamp: initial
      -webkit-box-orient: initial

  #cabecalho
    color: #4caf50
    font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif
    font-weight: 800 !important

  #imagem
    margin-left: 30%
    margin-right: 25%
    width: 40%
    height: 40%

  #logar
    border-radius: 8px

</style>
